import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { sortArrayByLocaleCompare } from '../../utils/sortArrayUtil';
import { LanguageIcon, LanguageSelector, LanguageSelectorBlock } from './style';

type BaseLanguageSelectorProps = {
  size?: 'small' | 'medium';
  showIcon?: boolean;
  iconSize?: '1x' | '2x' | '3x' | '4x' | '5x';
  languages: { displayName: string; value: string }[];
  changeLanguage: (e: React.MouseEvent<HTMLSelectElement>) => void;
  selectedLanguage: string;
};

type LanguageOption = {
  displayName: string;
  value: string;
};

const BaseLanguageSelector = ({
  size = 'medium',
  showIcon,
  iconSize = '1x',
  languages,
  changeLanguage,
  selectedLanguage,
}: BaseLanguageSelectorProps) => {
  const [value, setValue] = React.useState(selectedLanguage);

  const sortedLanguageOptions = sortArrayByLocaleCompare({
    array: languages,
    key: 'displayName',
    order: 'asc',
  });

  const onChange = e => {
    e.preventDefault();
    const { value } = e.target;
    setValue(value);
    changeLanguage(value);
  };

  return (
    <LanguageSelectorBlock size={size}>
      <LanguageSelector
        id="language-selector"
        onChange={onChange}
        value={value}
        aria-label="language-selector"
        role="combobox"
      >
        {sortedLanguageOptions.length > 0 ? (
          sortedLanguageOptions.map(({ displayName, value }) => (
            <option key={value} value={value}>
              {displayName}
            </option>
          ))
        ) : (
          <option value="en">English</option>
        )}
      </LanguageSelector>
      {showIcon && (
        <LanguageIcon>
          <FontAwesomeIcon size={iconSize} icon="globe-americas" />
        </LanguageIcon>
      )}
    </LanguageSelectorBlock>
  );
};

export default BaseLanguageSelector;
